import React from 'react';
import avatarImg from "../../../images/avatar.png";
import ProfileImageStyled from "../../../styled/ProfileImage"



const ProfileIcon = (props) => {
    const {profileImg, clickHandler} = props;
    //we use props to dynamically fetch profile image and display it
    return (

        <ProfileImageStyled>
            <button onClick={clickHandler}>
                <img src={profileImg || avatarImg} alt='profile icon'/>
            </button>

        </ProfileImageStyled>


    );


}

export default ProfileIcon;